<template>
  <div>
    <LoadingSpinner :loading="loading" :text="$lang.sending_data" />
    <b-row v-if="!loading" class="mx-0">
      <b-col cols="12" md="12" class="px-0">
        <b-row align-v="center">
          <b-col cols="9" md="">
            <b-form-group :label="`${label}: `">
              <requiredComponent
                v-if="requiredLabel"
                slot="label"
                :label="`${label}: `"
                :rules="$v.tag_selected.$params"
              />
              <selectFind
                :disabled="disabled"
                :options="tag_options"
                v-model="$v.tag_selected.$model"
                :value="tag_selected"
                :label="idTrack ? 'caption' : 'text'"
                :id="idTrack ? 'id' : 'value'"
                :loading="tag_selectedLoading"
                :multiple="multiple"
                placeholder="جستجو..."
                :isValid="
                  $v.tag_selected.$dirty ? !$v.tag_selected.$error : null
                "
                @removeItem="removeItem"
                @open="generateTagOptions()"
              />

              <b-form-invalid-feedback
                :style="{
                  display: $v.tag_selected.$error ? 'block' : 'none',
                }"
              >
                <div v-if="!$v.tag_selected.required">
                  {{ $lang.error_required | replace(label) }}
                </div>
              </b-form-invalid-feedback>
            </b-form-group>
          </b-col>
          <b-col cols="3" md="auto" v-if="isEditable">
            <b-button
              :disabled="disabled"
              v-b-tooltip.hover
              :title="`برای افزودن ${label} جدید روی این دکمه کلیک کنید`"
              class="mt-1"
              variant="success"
              @click="showForm = !showForm"
            >
              <i class="fas fa-plus" />
            </b-button>
          </b-col>
        </b-row>
      </b-col>
      <b-col
        v-if="showForm"
        cols="12"
        md="12"
        class="bg-light rounded py-3 mb-3"
      >
        <b-form-group>
          <requiredComponent
            slot="label"
            :label="`${label}: `"
            :rules="$v.caption.$params"
          />
          <b-form-input
            v-model="$v.caption.$model"
            type="text"
            autocomplete="off"
            :state="$v.caption.$dirty ? !$v.caption.$error : null"
          />
          <b-form-invalid-feedback
            :style="{
              display: $v.caption.$error ? 'block' : 'none',
            }"
          >
            <div v-if="!$v.caption.required">
              {{ $lang.error_required | replace(label) }}
            </div>
          </b-form-invalid-feedback>
        </b-form-group>

        <b-button
          v-if="isAdmin(parentPermissions)"
          variant="success"
          @click="submit"
          class="float-right"
        >
          <mdicon name="check" size="20" />
          {{ $lang.submitButton }}
        </b-button>
      </b-col>
    </b-row>
  </div>
</template>
<script>
import LoadingSpinner from "@/components/base/LoadingSpinner";
import { mapActions } from "vuex";
import { required, requiredIf } from "vuelidate/lib/validators";
import { pathOr, includes } from "ramda";
import { isAdmin, renderEumOptions, checkIsEditableEnum } from "@/shared/utils";

export default {
  validations: {
    tag_selected: {
      required: requiredIf((vm) => vm.requiredLabel),
    },
    caption: {
      required,
    },
  },
  components: {
    LoadingSpinner,
  },
  props: {
    category_name: {
      type: String,
      default: "",
    },
    parent_id: {
      type: Number,
      default: 0,
    },
    label: {
      type: String,
      default: "برچسب",
    },
    parentPermissions: {
      type: Array,
      default: () => [],
    },
    requiredLabel: {
      type: Boolean,
      default: true,
    },
    checkValidation: {
      type: Boolean,
      default: false,
    },
    multiple: {
      type: Boolean,
      default: false,
    },
    parentValue: {
      type: [Array, Object],
      default: null,
    },
    idTrack: {
      type: Boolean,
      default: false,
    },
    disabled: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      loading: false,
      showForm: false,
      tag_options: [],
      tag_selected: null,
      tag_selectedLoading: false,
      caption: null,
    };
  },
  computed: {
    addButtonMessage() {
      return this.showForm
        ? `جهت بستن فرم ایجاد تگ جدید بر روی دکمه <b class="text-danger">"بستن فرم"</b> کلیک نمایید`
        : `جهت مشاهده فرم ایجاد تگ جدید بر روی دکمه <b class="text-success">"مشاهده فرم"</b> کلیک نمایید`;
    },
    isEditable() {
      return checkIsEditableEnum(this.category_name);
    },
  },
  watch: {
    checkValidation(value) {
      // check validation field
      this.checkTagSelected(value);
    },
    tag_selected(data) {
      this.$emit("getSelected", data);
    },
    parentValue(data) {
      // set tag selected by parent data when is edit
      this.tag_selected = data;
    },
  },
  created() {
    this.generateTagOptions();
  },
  methods: {
    ...mapActions(["getAllEnumeration"]),
    pathOr,
    includes,
    isAdmin,
    renderEumOptions,
    checkIsEditableEnum,
    generateTagOptions() {
      // get tag options of enum in localStorage
      this.tag_options = renderEumOptions(this.category_name, this.idTrack);

      // set default value by parent value when mode is edit or set by is default option
      this.tag_selected =
        this.parentValue || this.tag_options.find((item) => item.is_default);
    },
    async submit() {
      this.$v.caption.$touch();
      if (this.$v.caption.$anyError) return;

      try {
        this.loading = true;
        const payload = {
          enum_caption: this.caption,
          category_name: this.category_name,
          parent_id: this.parent_id,
        };
        const url = this.$config.api_url + this.$config.resources.enum;
        const response = await this.$httpService.post(url, payload);
        await this.getAllEnumeration();
        this.generateTagOptions();
        this.showForm = false;
        this.caption = null;
        this.$notify.success(response.data.message);
      } catch (error) {
        this.$generateError(error);
      } finally {
        this.loading = false;
      }
    },
    checkTagSelected(state) {
      if (state) {
        this.$v.$reset();
        this.$emit("updateCheckValidation", false);
        return;
      }

      this.$v.tag_selected.$touch();
      if (this.$v.tag_selected.$anyError) return;
    },
    removeItem(item) {
      this.tag_selected = this.multiple
        ? [...this.tag_selected.filter((row) => row.value !== item.value)]
        : null;
    },
  },
};
</script>
